<p-toast></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<p-contextMenu #cm [model]="menuContextuel"></p-contextMenu>

<p-card *ngIf="!EstCharge()">
    <div class="fluid formgrid grid">
        <div class="flex flex-column gap-2 my-2 col-12 text-center">
            <p-progressSpinner></p-progressSpinner>
        </div>
    </div>
</p-card>

<div *ngIf="EstCharge()" class="grid">
    <div class="col-12">
        <p-card>
            <p-table #dt [value]="clesApi" dataKey="cleApiId" tableStyleClass="tableNormale" 
                [responsiveLayout]="'scroll'"
                [(contextMenuSelection)]="selectionCle"
                [contextMenu]="cm" [rowHover]="true" [rows]="25" [paginator]="true" [filterDelay]="0"
                [globalFilterFields]="['nom', 'creeParNom']">
                <ng-template pTemplate="caption">
                    <div class="flex flex-column md:flex-row align-items-start md:align-items-center justify-content-between gap-2">
                        <div class="flex flex-column sm:flex-row gap-2 w-full md:w-auto">
                            <span class="p-input-icon-left w-full sm:w-auto">
                                <i class="pi pi-search"></i>
                                <input pInputText type="text"
                                    (input)="dt.filterGlobal($event.target.value, 'contains')"
                                    placeholder="Recherche..." 
                                    class="w-full" />
                            </span>
                            <p-button icon="pi pi-plus" 
                                label="Nouvelle clé"
                                styleClass="p-button-success w-full sm:w-auto"
                                (click)="ajouterCle()" 
                                pTooltip="Générer une nouvelle clé API"
                                tooltipPosition="top"></p-button>
                        </div>
                        <h5 class="titreTableau m-0 hidden md:block">Gestion des clés API</h5>
                        <div></div>
                    </div>
                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <th pSortableColumn="nom">
                            <div class="flex justify-content-between align-items-center">
                                Nom / Application
                                <p-sortIcon field="nom"></p-sortIcon>
                                <p-columnFilter type="text" field="nom" display="menu" class="ml-auto">
                                </p-columnFilter>
                            </div>
                        </th>
                        <th pSortableColumn="clientId">
                            <div class="flex justify-content-between align-items-center">
                                Client ID
                                <p-sortIcon field="clientId"></p-sortIcon>
                            </div>
                        </th>
                        <th pSortableColumn="dateCreation">
                            <div class="flex justify-content-between align-items-center">
                                Créée le
                                <p-sortIcon field="dateCreation"></p-sortIcon>
                            </div>
                        </th>
                        <th pSortableColumn="creeParNom" class="hidden lg:table-cell">
                            <div class="flex justify-content-between align-items-center">
                                Créée par
                                <p-sortIcon field="creeParNom"></p-sortIcon>
                            </div>
                        </th>
                        <th pSortableColumn="dateExpiration" class="hidden xl:table-cell">
                            <div class="flex justify-content-between align-items-center">
                                Expiration
                                <p-sortIcon field="dateExpiration"></p-sortIcon>
                            </div>
                        </th>
                        <th style="min-width: 8rem; width: 8rem;">Actions</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-cle>
                    <tr [pContextMenuRow]="cle" class="cursor-pointer">
                        <td>
                            <div class="flex align-items-center">
                                <i class="pi pi-key mr-2" style="color: #FBC02D;"></i>
                                <span class="font-semibold">{{cle.nom}}</span>
                            </div>
                        </td>
                        <td>
                            <div class="flex align-items-center gap-1">
                                <span>{{cle.clientId}}</span>
                                <p-button icon="pi pi-copy" text pTooltip="Copier le Client ID" (click)="copierClientId(cle.clientId)"></p-button>
                            </div>
                        </td>
                        <td>
                            <span class="hidden md:inline">{{cle.dateCreation | date:'yyyy-MM-dd HH:mm'}}</span>
                            <span class="md:hidden">{{cle.dateCreation | date:'yyyy-MM-dd'}}</span>
                        </td>
                        <td class="hidden lg:table-cell">{{cle.creeParNom}}</td>
                        <td class="hidden xl:table-cell">
                            <p-tag *ngIf="cle.dateExpiration" [value]="cle.dateExpiration | date:'yyyy-MM-dd'" 
                                   [severity]="(cle.dateExpiration | date:'yyyy-MM-dd') < (today | date:'yyyy-MM-dd') ? 'danger' : 'info'"></p-tag>
                            <span *ngIf="!cle.dateExpiration" class="text-500">Jamais</span>
                        </td>
                        <td (click)="$event.stopPropagation()">
                            <div class="flex gap-1 justify-content-end">
                                <p-button icon="pi pi-pencil" 
                                        text 
                                        severity="success"
                                        (click)="ouvrirDetail(cle)"
                                        pTooltip="Modifier"
                                        tooltipPosition="top"></p-button>
                                <p-button icon="pi pi-refresh" 
                                        text 
                                        severity="warning"
                                        (click)="confirmerRegeneration(cle)"
                                        pTooltip="Régénérer la clé"
                                        tooltipPosition="top"></p-button>
                                <p-button icon="pi pi-trash" 
                                        text 
                                        severity="danger"
                                        (click)="confirmerSuppression(cle)"
                                        pTooltip="Supprimer"
                                        tooltipPosition="top"></p-button>
                            </div>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="5" class="text-center">Aucune clé API trouvée.</td>
                    </tr>
                </ng-template>
            </p-table>
        </p-card>
    </div>
</div>

